<template>
	<section v-if="results">
    <div class="job-cards">
			<template v-for="(job, j) in results" :key="j">
				<job-card-slim :payload="job"></job-card-slim>
			</template>
		</div>
	</section>

  <button v-if="(results.length > 6)" class="btn btn-blue-dark btn-rounded">Load more</button>
</template>

<script>
	import algoliasearch from 'algoliasearch';
  import JobCardSlim from './JobCardSlim';

	export default {
		name: 'JobsRelated',

		components: {
      JobCardSlim
		},

		props: {
			org_main_id: {
				type: String
			},
			job_title: {
				type: String
			}
		},

		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'listings-test' : 'listings-live',
				searchObject: {
					hitsPerPage: 3,
					facets: ["option-job-title"],
					facetFilters: [["published:true"],[`option-job-title:${this.job_title}`]]
				},
				results: false
			}
		},

		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);

			this.index
				.search('', this.searchObject)
				.then((results) => {
					// console.log("More jobs search raw results:", results);
					if (results.nbHits > 0) {
						this.filteredResults = results.hits.filter((el) => {
							return el['org-main-id'] !== this.org_main_id;
						});
						this.results = this.filteredResults.length ?  this.filteredResults : false;
					} else {
						this.results = false;
					}
				});
		}
	}
</script>
